import { gql } from '@apollo/client';
import { PROSPECTO_FRAGMENT } from './prospectos';

export const OBTENER_USO_CFDI = gql`
  query {
    datosFiscales {
      obtenerUsoCfdi {
        id
        nombre
      }
    }
  }
`;

export const OBTENER_FORMA_PAGO = gql`
  query {
    datosFiscales {
      obtenerFormaPago {
        id
        nombre
      }
    }
  }
`;

export const OBTENER_METODO_PAGO = gql`
  query {
    datosFiscales {
      obtenerMetodosPago {
        id
        nombre
      }
    }
  }
`;
export const OBTENER_REGIMEN_FISCAL = gql`
  query {
    datosFiscales {
      obtenerRegimenFiscal {
        id
        descripcion
      }
    }
  }
`;
export const OBTENER_PAGINADO_DATOSFISCALES = gql`
  query DatosFiscalesPage(
    $query: QueryInput!
    $origen: String
    $ocupacion: String
    $estado: String
    $municipio: String
    $cultivoTipo: String
    $vendedorId: ID
    $zona: String
    $calificacion: String
    $tipoCliente: TipoClienteEnum
  ) {
    datosFiscales {
      obtenerPaginado(
        query: $query
        origen: $origen
        ocupacion: $ocupacion
        estado: $estado
        municipio: $municipio
        cultivoTipo: $cultivoTipo
        vendedorId: $vendedorId
        zona: $zona
        calificacion: $calificacion
        tipoCliente: $tipoCliente
      ) {
        totalItems
        items {
          id
          folio
          fechaCreacion
          razonSocial
          rfc
          prospecto {
            ...ProspectoFragment
            numeroSucursales
            isProspecto
            razonSocialFiscal
          }
        }
      }
    }
  }
  ${PROSPECTO_FRAGMENT}
`;
export const OBTENER_DOCUMENTOS = gql`
  query ($id: ID!) {
    datosFiscales {
      obtenerDocumentosAsync(id: $id) {
        id
        fechaCreacion
        datosFiscalesDocTipo {
          id
          nombre
          fechaCreacion
        }
        documento {
          id
          key
        }
      }
    }
  }
`;
export const OBTENER_TODOS_DOC_FISCALES_TIPOS = gql`
  query {
    datosFiscales {
      obtenerDatosFiscalesDocTipoTodos {
        id
        nombre
        fechaCreacion
      }
    }
  }
`;

export const OBTENER_DATO_FISCAL_POR_PROSPECTOID = gql`
  query ($prospectoId: ID!) {
    datosFiscales {
      obtenerDatosFiscalesPorProspectoId(prospectoId: $prospectoId) {
        id
        razonSocial
        rfc
        telefono
        correo
        usoCfdiId
        formaPagoId
        metodoPagoId
        regimenFiscalId
        tipoPersona
        tipoPago
        diasCredito
        prospecto {
          ...ProspectoFragment
          numeroSucursales
          isProspecto
          razonSocialFiscal
        }
      }
    }
  }
  ${PROSPECTO_FRAGMENT}
`;
